import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { variantHistoryModalSlice, VariantHistoryModalDispatchParams, VariantHistoryModalState } from '@REDUCERS';

function createHistoryModalHook() {
    return function useVariantHistoryModal(equalityFn?: EqualityFn<VariantHistoryModalState>) {
        const state = useAppSelector((store) => store.variantHistoryModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: VariantHistoryModalDispatchParams) => dispatch(variantHistoryModalSlice.actions.open(params)),
            close: () => dispatch(variantHistoryModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createHistoryModalHook();
